import AppLogo from '@/components/icons/Logo';
import AuthLogo from '@/assets/svg/Logo';
import { useAppBranding } from '@/contexts/AppBrandingContext';
import { cn } from '@/lib/utils';

type Props = {
    variant?: 'app' | 'auth';
    width?: string;
    height?: string;
    className?: string;
    imgClassName?: string;
};

export default function BrandedLogo({
    variant = 'app',
    width = '74',
    height = '46',
    className,
    imgClassName,
}: Props) {
    const { branding } = useAppBranding();
    const url = branding?.logo_url;

    if (url) {
        return (
            <span className={cn('inline-flex items-center justify-center', className)}>
                <img
                    src={url}
                    alt={branding?.company_name ?? ''}
                    className={cn(
                        'w-auto object-contain',
                        variant === 'auth' ? 'max-h-[120px] max-w-[200px]' : 'max-h-[46px] max-w-[140px]',
                        imgClassName,
                    )}
                    style={variant === 'app' ? { maxHeight: `${height}px` } : undefined}
                />
            </span>
        );
    }

    if (variant === 'auth') {
        return (
            <span className={className}>
                <AuthLogo />
            </span>
        );
    }

    return (
        <span className={className}>
            <AppLogo width={width} height={height} />
        </span>
    );
}
